import { registerApi as api } from '../../api';

export const fetchContractorsData = async (current_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const response = await api.get(`/get_contractor/${current_month}`, {
      params: {
        client_id: client_ID
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const updateContractors = async (id, contractorsData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_contractor/${id}`, contractorsData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const deleteContractors = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_contractor/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

// export const ContractorsUpload = async (contractorsDataInput) => {
//   console.log("contractorsDataInput api first", contractorsDataInput);
  
//   try {
//     const token = sessionStorage.getItem('token');
//     console.log("token in contractors api", token);
//     const selectedClientID = sessionStorage.getItem('selectedClient')
//     const response = await api.post('/upload_contractor', contractorsDataInput, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//       params : {
//         'selectedClientID' : selectedClientID
//       }
//     });
//     console.log("upload contractors response api", response);
    
//     return {
//       data: response,
//       status: response.status,
//     };
//   } catch (error) {
//     throw error.response.data.error;
//   }
// };

export const ContractorsUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_contractor', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params : {
        'selectedClientID' : selectedClientID
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};

export const multiDeleteContractors = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_contractor', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
